import { PrismButton, PrismDialog, PrismInputText, PrismInputTextarea } from "@prism-ui/react";
import type { EventDraft } from "./ProjectFairs";

interface FairCopyModalProps {
  show: boolean;
  draft: EventDraft;
  saving: boolean;
  onChange: (updater: (prev: EventDraft) => EventDraft) => void;
  onSave: () => void;
  onCancel: () => void;
}

// Fair Copy & Messaging owns the title and welcome copy. Directions live with the schedule,
// while closing content is managed as one public row by Closing Banner.
const FairCopyModal = ({ show, draft, saving, onChange, onSave, onCancel }: FairCopyModalProps) => (
  <PrismDialog open={show} close-method="user" onPrismClose={onCancel} setAriaLabel="Fair Copy & Messaging">
    <span slot="header">Fair Copy &amp; Messaging</span>
    <div className="project-fairs-modal-body">
    <div className="project-fairs-grid">
      <PrismInputText
        label="Event Title"
        value={draft.title}
        onPrismInput={(e: CustomEvent<{ value: string }>) =>
          onChange((prev) => ({ ...prev, title: e.detail?.value || "" }))
        }
      />
    </div>
    <div className="project-fairs-textareas">
      <PrismInputTextarea
        label="Welcome Message"
        rows={6}
        value={draft.welcome_msg}
        onPrismInput={(e: CustomEvent<{ value: string }>) =>
          onChange((prev) => ({ ...prev, welcome_msg: e.detail?.value || "" }))
        }
      />
    </div>
    </div>
    <PrismButton slot="footer" tone="secondary" display="outline" onPrismClick={onCancel}>
      Cancel
    </PrismButton>
    <PrismButton slot="footer" tone="primary-brand" display="fill" disabled={saving} loading={saving} onPrismClick={onSave}>
      Save
    </PrismButton>
  </PrismDialog>
);

export default FairCopyModal;
